import React from "react";
import { useTranslation } from "react-i18next";
import { S3_BASE_URL } from "../../utils/Constants";
import { Star, Package, MessageSquare, Utensils } from 'lucide-react';

const MealPerformanceCard = ({ meals, isLoading }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border p-6 animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-40 mb-4"></div>
        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex items-center space-x-4">
              <div className="h-12 w-12 bg-gray-200 rounded-lg"></div>
              <div className="flex-1">
                <div className="h-4 bg-gray-200 rounded w-32 mb-2"></div>
                <div className="h-3 bg-gray-200 rounded w-20"></div>
              </div>
              <div className="h-4 bg-gray-200 rounded w-16"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!meals || meals.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-sm border p-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">
          {t("topPerformingMeals")}
        </h3>
        <div className="text-center py-8">
          <Utensils className="w-12 h-12 text-gray-400 mx-auto mb-3" />
          <p className="text-gray-500">{t("noMealsFound")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        {t("topPerformingMeals")}
      </h3>
      <div className="space-y-4">
        {meals.map((meal, index) => (
          <div key={meal.mealId} className="flex items-center space-x-4 rtl:space-x-reverse">
            <div className="flex-shrink-0 relative">
              {meal.imageUrl ? (
                <img
                  src={S3_BASE_URL + "/" + meal.imageUrl}
                  alt={meal.name}
                  className="h-12 w-12 rounded-lg object-cover"
                />
              ) : (
                <div className="h-12 w-12 bg-gray-200 rounded-lg flex items-center justify-center">
                  <Utensils className="w-5 h-5 text-gray-400" />
                </div>
              )}
              <span className="absolute -top-2 -left-2 rtl:-right-2 rtl:left-auto bg-blue-600 text-white text-xs rounded-full h-6 w-6 flex items-center justify-center">
                {index + 1}
              </span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate mb-2">
                {meal.name}
              </p>
              <div className="flex items-center space-x-4 rtl:space-x-reverse text-xs text-gray-500">
                <div className="flex items-center space-x-1 rtl:space-x-reverse">
                  <Star className="w-3 h-3 text-yellow-500" />
                  <span>{meal.rating?.toFixed(1) || t('dashboard.notAvailable')}</span>
                </div>
                <div className="flex items-center space-x-1 rtl:space-x-reverse">
                  <Package className="w-3 h-3 text-blue-500" />
                  <span>{meal.orderCount || 0} {t("orders")}</span>
                </div>
                <div className="flex items-center space-x-1 rtl:space-x-reverse">
                  <MessageSquare className="w-3 h-3 text-green-500" />
                  <span>{meal.reviewCount || 0} {t("reviews")}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MealPerformanceCard;
